import React from 'react';
import styled from 'styled-components';
import {HeroContainer} from "../components/Container/Container";
import {P2, Title} from "../components/Kit/Kit";

const Container = styled.div`
    padding: 20px;
    
    @media(min-width: 768px) {
        padding: 20px 100px;
    }
    
      @media(min-width: 1200px) {
        padding: 20px 200px;
    }
    
    h1 {
      margin-bottom: 20px;
    }
`;

const TextContainer = styled.div`
  p {
     margin-bottom: 16px;

    p{
      text-align: left;
      margin-bottom: 16px;
    }
  }
`;

const PrivacyPolicy = (props) => {
    const {title, content} = props.data.privacy.edges[0].node;
    return (
      <HeroContainer>
          <Container>
              <Title>{title}</Title>
              <TextContainer>
                  <P2
                    dangerouslySetInnerHTML={{__html: content}}
                  />
              </TextContainer>
          </Container>
      </HeroContainer>
    )
};

export default PrivacyPolicy;

export const privacyQuery = graphql`
    query privacyQuery {
        privacy: allWordpressPage(filter: {title: {eq: "Privacy Policy"}}) {
            edges {
                node {
                    title
                    content
                }
            }
        }
    }
`;




// WEBPACK FOOTER //
// ./src/pages/privacy-policy.js